<template>
  <modal-template ref="modal" size="md" title="Importar Dados via PDF" :type-modal="MODAL_TYPE">
    <div class="modal-content__main">

      <d-form-row class="mb-4" @click.stop.prevent>
        <d-col v-if="availableTemplates">
          <label class="font-weight-bold">Selecione Template</label>
          <d-select class="form-control" v-model="selectedTemplate">
            <option :value="null">Escolha um Template</option>
            <option v-for="(tpl, idx) in availableTemplates" :key="idx" :value="tpl.type">
              {{ tpl.label }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>

      <d-form-row v-if="selectedTemplate && !file">
        <d-col >
          <vue-dropzone
            id="dropzonePdf"
            ref="dropzonePdf"
            :useCustomSlot="true"
            :options="dropzoneOptions"
            @vdropzone-files-added="addFile"
          >
            <div class="dropzone-custom-content text-center py-4 text-muted">
              <i class="fas fa-file-pdf fa-3x mb-2 text-danger"></i>
              <h5 class="m-0">Clique ou arraste o PDF aqui</h5>
            </div>
          </vue-dropzone>
        </d-col>
      </d-form-row>

      <d-form-row v-if="file" class="mt-3">
        <d-col>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold text-success">
              <i class="fas fa-check-circle mr-1"></i> Arquivo pronto para importação
            </span>
            <d-button size="sm" theme="danger" outline @click="removeFile">
              <i class="fas fa-trash mr-1"></i> Trocar PDF
            </d-button>
          </div>

          <iframe
            :src="pdfPreviewUrl + '#toolbar=1&navpanes=0&view=FitH'"
            width="100%"
            height="400px"
            class="border rounded shadow-sm">
          </iframe>
        </d-col>
      </d-form-row>
    </div>

    <div slot="actions" class="modal-content__control w-100 d-flex justify-content-between align-items-center">
      <small class="text-muted" v-if="file">Arquivo: {{ file.name }}</small>

      <d-button type="button" :disabled="!file || !selectedTemplate" @click="processPdf()" class="btn btn-sm btn-primary">
        Processar PDF
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import PdfService from '_services/rest/modules/pdf';
import { _IMPORT_PDF_SUCCESS_, IMPORT_PDF_MODAL } from '../SampleModel';


export default {
  name: 'import-pdf-modal',
  components: {
    ModalTemplate,
    vueDropzone,
  },
  data() {
    return {
      MODAL_TYPE: IMPORT_PDF_MODAL,
      loading: false,
      selectedTemplate: null,
      file: null,
      pdfPreviewUrl: null,
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        acceptedFiles: '.pdf',
        maxFiles: 1,
        addRemoveLinks: true,
        hiddenInputContainer: '.modal-content__main',
      },
    };
  },
  computed: {
    availableTemplates() {
      const { pdfTemplates } = this.$store.state.settings;

      if (pdfTemplates && pdfTemplates.templates) {
        return pdfTemplates.templates;
      }

      return [];
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'getSettings']),
    addFile(files) {
      if (!files) return;
      [this.file] = files;
      this.pdfPreviewUrl = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.file = null;
      this.pdfPreviewUrl = null;
      if (this.$refs.dropzonePdf) this.$refs.dropzonePdf.removeAllFiles();
    },
    closeModal() {
      this.removeFile();
      this.setToggle({ type: this.MODAL_TYPE, bool: false });
    },
    processPdf() {
      if (!this.file || !this.selectedTemplate) return;

      this.loading = true;

      PdfService.importMapped(this.file, this.selectedTemplate)
        .then(response => {
          const mappedData = response.data ? response.data : response;

          Events.$emit(_IMPORT_PDF_SUCCESS_, mappedData);

          this.activeAlert({ message: 'Dados importados com sucesso!', theme: 'success' });
          this.closeModal();
        })
        .catch(err => {
          console.error(err);
          this.activeAlert({ message: 'Erro ao importar PDF.', theme: 'danger' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getSettings();
  },
};
</script>

<style lang="scss" scoped>
  label {
    margin-bottom: 0;
  }
  picture {
    margin-right: 10px;
    text-align: center;
    position: relative;
    &:hover {
      .delete-img {
        display: block;
      }
    }
    .delete-img {
      position: absolute;
      top: 5px;
      right: 5px;
      color: red;
      cursor: pointer;
      font-size: 15px;
      display: none;
    }
  }
  .vue-dropzone {
    margin-top: 10px;
    border-radius: 5px;
    border-style: dashed;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .dz-details {
    white-space: normal;
    overflow: visible;
    text-overflow: ellipsis;
    font-size: 12px;
    color: #333;
    max-width: 100%;
    padding: 5px 0;
  }

  ::v-deep .dz-image img {
    max-width: 300px;
    max-height: 300px;
    width: auto;
    height: auto;
    object-fit: contain;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  ::v-deep .dz-remove {
    margin: 5px 4px;
    padding: 4px 2px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    border: 1px solid #ffffff;
    transition: 0.3s ease-in-out;
  }

  ::v-deep .dz-remove:hover {
    background: #d9534f;
    border: 1px solid #d9534f;
    color: white;
    text-decoration: none;
  }
</style>
